import { axiosPrivate } from "../../../api/axios";
import { useEffect, useState } from "react";
import { useLogging } from "../../hooks/useLogging/useLogging";
import { LogLevel } from "../../hooks/useLogging/Logging-types";
import { recursiveTokenFilter } from "../../utils/tokenReplacement";
/**
 * GetCompanyProviderModel() - Fetch Company provider model
 * This makes a GET request to /React/GetCompanyProviderModel
 *
 * @return {*}
 */
export const GetCompanyProviderModel = () => {
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState();
    const [error, setError] = useState();
    const [tokenMap, setTokenMap] = useState();
    const { datadogLog } = useLogging();
    useEffect(() => {
        setLoading(true);
        axiosPrivate
            .get(`/React/GetCompanyProviderModel?timestamp=${new Date().getTime()}`)
            .then((res) => {
            var _a;
            if (!((_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.success)) {
                setError("Something unexpected happened while loading the page. Code: CA1");
                datadogLog("Failed to get CompanyProvider model", LogLevel.ERROR);
                return;
            }
            setError(undefined);
            const tokenMap = new Map();
            for (const key in res.data.tokenMap) {
                tokenMap.set(key, res.data.tokenMap[key]);
            }
            setTokenMap(tokenMap);
            recursiveTokenFilter(res.data.companyText, false, tokenMap);
            setData(res.data);
        })
            .catch((e) => {
            console.error(e);
            setData(undefined);
            setError(`Something unexpected happened while loading the page. Code: CA2`);
            datadogLog("Failed to get CompanyProvider model", LogLevel.ERROR, undefined, e);
        })
            .then(() => setLoading(false));
    }, []);
    return { loading, data, error, tokenMap };
};
